export { HeroProjectDescription } from './HeroProjectDescription'
